import {DatabaseCode, toDatabaseCode, toDatabaseCodeSafely} from "../database-code";

export type RrcAutoSignStrategy = DatabaseCode;

const selected: RrcAutoSignStrategy = {
  code: "SELECTED",
  displayValue: {
    id: "common.entity.rrcautosignstrategy.selected",
    defaultMessage: "Selected",
  },
};

const assignmentConfig: RrcAutoSignStrategy = {
  code: "ASSIGNMENT_CONFIG",
  displayValue: {
    id: "common.entity.rrcautosignstrategy.assignmentconfig",
    defaultMessage: "Assignment Config",
  },
};

export const rrcAutoSignStrategy = {
  selected,
  assignmentConfig,
};

export const rrcAutoSignStrategies: RrcAutoSignStrategy[] = Object.values(rrcAutoSignStrategy);

export const toRrcAutoSignStrategy = (code: string): RrcAutoSignStrategy =>
  toDatabaseCode(code, rrcAutoSignStrategies);

export const toRrcAutoSignStrategySafely = (
  code: string | undefined,
  defaultValue: RrcAutoSignStrategy | undefined = undefined
): RrcAutoSignStrategy | undefined => toDatabaseCodeSafely(code, rrcAutoSignStrategies, defaultValue);
